<template>
  <div class="performance-display-container">
    <b class="performance-display-header text-center">{{ header }}</b>
    <div class="display-content">
      <slot name="body">
        <ComparisonDisplay v-bind="$props" widget>
          <template #tooltip>
            <ComparisonTooltip
              :point="currentPoint"
              :metric="tooltipHeader"
              :format-value="formatValue"
              :cumulative="false"
              :invert-color="invertColor"
            />
          </template>
        </ComparisonDisplay>
      </slot>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import ComparisonTooltip from "@/components/Chart/ComparisonTooltip.vue";
import ComparisonDisplay from "./ComparisonDisplay.vue";

export default {
  components: {
    ComparisonDisplay,
    ComparisonTooltip
  },
  props: {
    header: {
      type: String,
      default: "Value"
    },
    base: {
      type: Object,
      default: null
    },
    comparison: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    invertColor: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(["dashboardFilters"]),
    currentPoint() {
      const base = { ...this.base, date: this.dashboardFilters.base_range };
      const comparison = {
        ...this.comparison,
        date: this.dashboardFilters.comparison_range
      };
      return {
        base,
        comparison
      };
    },
    tooltipHeader() {
      return this.capitalize(this.header.toLowerCase());
    }
  },
  methods: {
    formatValue(value) {
      if (this.type === "currency") {
        return this.dollars(value);
      } else if (this.type === "percentage") {
        return this.formatPercent(value);
      } else {
        return (value || 0).toLocaleString("en-us");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.performance-display-container {
  display: flex;
  flex-direction: column;
  justify-content: baseline;
  align-items: center;
  padding: 5px 0px;
  width: 25%;
  span {
    display: block;
  }
}

.display-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
